import { NUMBER_PATTERN } from '../../../../../common/constants';
import { Validators } from '@angular/forms';
import { ControlProperty } from '../../../../../common';
import { UserDeactivationApproach } from '../constants';

export class UserDeactivationSettings {
  deactivationApproach: UserDeactivationApproach = null;
  deactivationDate: number = null;
  monthOfInactivity: number = null;

  constructor(params?: UserDeactivationSettings) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class UserDeactivationSettingsForm {
  constructor(
    model: UserDeactivationSettings,
    public deactivationApproach: ControlProperty<UserDeactivationApproach> = [
      model.deactivationApproach,
      [Validators.required],
    ],
    public deactivationDate: ControlProperty<number> = [
      {
        value: model.deactivationDate,
        disabled: model.deactivationApproach === UserDeactivationApproach.MonthOfInactivity,
      },
      [Validators.required],
    ],
    public monthOfInactivity: ControlProperty<number> = [
      {
        value: model.monthOfInactivity,
        disabled: model.deactivationApproach === UserDeactivationApproach.FixedDate,
      },
      [Validators.pattern(NUMBER_PATTERN), Validators.maxLength(2), Validators.required],
    ],
  ) {}
}
